export const environment = {
  ssoUrl: 'https://www.cityu.edu.hk/sro/studentlan/sso-auth-staging.ashx',
  ordsUrl: 'https://esmiscdev.esu.cityu.edu.hk/rests/ho_api/srims',
  portalUrl: 'https://portal-uat.cityu-sro.hk/redirect',
  env: 'staging',
};
